import { getItemsExtrasHistorico } from "../services/comprasService";
import { FormatoFecha } from "../utils/FormatFecha";
const dataInicial = {
    listExtrasItemsHistorial: [],
    pagina: 0,
    registros: 10,
    busqueda: FormatoFecha({date: new Date(), formato: "MMddyyyy"}),
    total: 0,
    exito: 0,
}

const GET_EXTRAS_CONTRATADOS_HISTORIAL_ALL = "GET_EXTRAS_CONTRATADOS_HISTORIAL_ALL"
const GET_EXTRAS_CONTRATADOS_HISTORIAL_PAGINA = "GET_EXTRAS_CONTRATADOS_HISTORIAL_PAGINA"
const GET_EXTRAS_CONTRATADOS_HISTORIAL_REGISTROS = "GET_EXTRAS_CONTRATADOS_HISTORIAL_REGISTROS"
const GET_EXTRAS_CONTRATADOS_HISTORIAL_BUSQUEDA = "GET_EXTRAS_CONTRATADOS_HISTORIAL_BUSQUEDA"

//* metodos para finanzas
export default function extrasContratadosHistorialReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_EXTRAS_CONTRATADOS_HISTORIAL_ALL:
            return { ...state, listExtrasItemsHistorial: action.payload.listExtrasItemsHistorial, total: action.payload.total }
        case GET_EXTRAS_CONTRATADOS_HISTORIAL_PAGINA:
            return { ...state, listExtrasItemsHistorial: action.payload.listExtrasItemsHistorial, pagina: action.payload.pagina, total: action.payload.total }
        case GET_EXTRAS_CONTRATADOS_HISTORIAL_REGISTROS:
            return { ...state, listExtrasItemsHistorial: action.payload.listExtrasItemsHistorial, registros: action.payload.registros, total: action.payload.total }
        case GET_EXTRAS_CONTRATADOS_HISTORIAL_BUSQUEDA:
            return { ...state, listExtrasItemsHistorial: action.payload.listExtrasItemsHistorial, busqueda: action.payload.busqueda, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros }
        default:
            return state;
    }
}

export const obtenerExtrasHitoricoAction = () => async (dispatch, getSate) => {
    const { busqueda, pagina, registros } = getSate().extrasContratadosHistorial
    return await getItemsExtrasHistorico({ Pagina: pagina + 1, fecha: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_EXTRAS_CONTRATADOS_HISTORIAL_ALL,
            payload: {
                listExtrasItemsHistorial: Response.compras,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerExtrasHistoricoPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { busqueda, registros } = getSate().extrasContratadosHistorial
    return await getItemsExtrasHistorico({ Pagina: Pagina + 1, fecha: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_EXTRAS_CONTRATADOS_HISTORIAL_PAGINA,
            payload: {
                listExtrasItemsHistorial: Response.compras,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerExtrasHistoricoRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { busqueda, pagina } = getSate().extrasContratadosHistorial
    return await getItemsExtrasHistorico({ fecha: busqueda, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_EXTRAS_CONTRATADOS_HISTORIAL_REGISTROS,
            payload: {
                listExtrasItemsHistorial: Response.compras,
                total: Response.Total,
                registros: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerExtrasHistoricoBusquedaAction = ({ Referencia }) => async (dispatch, getSate) => {
    return await getItemsExtrasHistorico({ fecha: Referencia, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registros }).then(Response => {
        dispatch({
            type: GET_EXTRAS_CONTRATADOS_HISTORIAL_BUSQUEDA,
            payload: {
                listExtrasItemsHistorial: Response.compras,
                total: Response.Total,
                busqueda: Referencia,
                registros: dataInicial.registros,
                pagina: dataInicial.pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
